import { render, staticRenderFns } from "./PacoteKitList.vue?vue&type=template&id=2f845776&scoped=true"
import script from "./PacoteKitList.vue?vue&type=script&lang=js"
export * from "./PacoteKitList.vue?vue&type=script&lang=js"
import style0 from "./PacoteKitList.vue?vue&type=style&index=0&id=2f845776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f845776",
  null
  
)

export default component.exports